import ReactDOM from 'react-dom';
import $ from 'jquery';
import React from "react";
import EXIF from 'exif-js';

/**
 * Serialize object to string.
 *
 * @param   {object} obj    - Object incoming
 * @returns {string}        - Object as Get params string
 */
export function serializeParams(obj) {
    return Object.keys(obj).reduce(function(a,k) {a.push(k+'='+encodeURIComponent(obj[k]));return a},[]).join('&');
}

/**
 * AJAX function.
 *
 * @param {string} url     - Request URL
 * @param {string} method  - Request type ('post' || 'get')
 * @param {object} params  - Object with params (for files { name: 'sasha' (sended to $_POST[]), files: { custom_filename: element.files[0] } (sended to $_FILES[]))
 * @param {object} options - Object with options. Available options:
 *     response_json{bool} - Type of response (JSON or not)
 *     func_waiting{func}  - Function while waiting
 *     func_callback{func} - Function on success result
 *     func_error{func}    - Function on error result
 *     func_progress{func} - Function on uploading progress
 */
var count_attemp = 0;
export function AJAX(url, method, params, options) {
    var xhr = null;
 //   console.log('send: ' + params.action);
    if (params.step)
        console.log('step: ' + params.step);
    try { // For: chrome, firefox, safari, opera, yandex, ...
        xhr = new XMLHttpRequest();
    } catch(e) {
        try { // For: IE6+
            xhr = new ActiveXObject("Microsoft.XMLHTTP");
        } catch(e1) { // if JS not supported or disabled
            if (typeof Bugsnag !== 'undefined' && Bugsnag.notify) {
                var error = new Error('Browser Not supported!');
                Bugsnag.notify(error);
            }
            console.log("Browser Not supported!");
            return;
        }
    }

    xhr.onreadystatechange = function() {

        // ready states:
        // 0: uninitialized
        // 1: loading
        // 2: loaded
        // 3: interactive
        // 4: complete

        if (xhr.readyState == 4) { // when result is ready

            var response_text = xhr.responseText;

//            console.log(response_text);

            if ('response_json' in options && options.response_json) {
                try {
                    response_text = JSON.parse(response_text);
                } catch (e) { }
            }

            if (xhr.status === 200) { // on success
                count_attemp = 0;
                if ('func_callback' in options && typeof options.func_callback == 'function') {
                    if(response_text !== undefined && response_text.errors !== undefined && response_text.errors.booking !== undefined && parseInt(response_text.errors.booking, 10) === 1) {
                        hidePreloader();
                        close_popup();
                        switch (response_text.errors.main) {
                            case 'booking_not_found':
                                show_not_found_booking_popup();
                                break;
                            case 'unlock_fail':
                            case 'lock_fail':
                                show_error_booking_popup(response_text.errors.main);
                                break;
                            default:
                                show_error_booking_popup();

                        }
                        return false;
                    }

                    var fc = options.func_callback;
                    fc(response_text);
                    // console.log(response_text);
                }
            }

            else { // on error
                if(xhr.status === 0) {
                   response_text = {message: 'Failed to connect to the server, please check your internet connection and try again.'};
                }
                else if (!response_text || !response_text.message) {
                        response_text = {message: xhr.statusText};
                }

                if (params.files) {
                    if(count_attemp < 3) {
                        count_attemp++;
                    } else {
                        response_text = {message: 'Your attempts to upload have been unsuccessful. <br/>Please use the call Go With The Gecko contact button to call for support.'};
                    }
                }

                if (typeof Bugsnag !== 'undefined' && Bugsnag.notify) {
                    var error = new Error(response_text);
                    Bugsnag.notify(error);
                }

                console.log(response_text);

                // console.log(xhr.status + ': ' + response_text.message);
                if ('func_error' in options && typeof options.func_error == 'function') {
                    var fe = options.func_error;
                    fe(response_text, xhr);
                }
            }
        } else { // waiting for result
            if ('func_waiting' in options && typeof options.func_waiting == 'function') {
                var fw = options.func_waiting;
                fw();
            }
        }
    };

    var data = null;

    if (params.files) {
        method = 'POST';

        data = new FormData();
        for (var index_param in params) {
            if (typeof params[index_param] == 'object') {
                for (var index_file in params[index_param]) {
                    data.append(index_file, params[index_param][index_file]);
                }
            } else {
                data.append(index_param, params[index_param]);
            }
        }

        if ('func_progress' in options && typeof options.func_progress == 'function') {
            xhr.upload.onprogress = function(event) {
                // 'progress: ' + event.loaded + ' / ' + event.total;
                var fp = options.func_progress;
                fp(event);
            };
        }
    } else {
        data = serializeParams(params);
    }

    method = method.toUpperCase();

    if (method == 'GET' && data) {
        url += '?' + data;
    }

    xhr.open(method, url, true);

    if (!params.files) {
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    }

    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send(data);
}

/**
 * @param value
 *
 * @returns {boolean}
 */
export function is_option_empty(value)
{
    return value === '' || value === ' ' || value == null || value === 'null';
}

export function showPreloader() {
    $("#id_loading").css('display', 'block');
}
window.showPreloader = showPreloader;

export function hidePreloader() {
    $("#id_loading").css('display', 'none');
}
window.hidePreloader = hidePreloader;

/**
 * @param content
 */
export function show_success_popup(content) {
    let c = <div className="py-4 mx-3 text-center">
        {content}
        <div className="small-lizard-with-thumb-up mx-auto mt-1"/>
    </div>;
	show_popup(c, {status: 'success', auto_close: true});
}

/**
 * @param content
 */
export function show_error_popup(content) {
    let c = <div className="py-4 mx-3 text-center">
        {content}
    </div>;
	show_popup(c, {status: 'error', auto_close: true});
}

/**
 * @param {string|object} content
 * @param {object} options
 */
export function show_popup(content, options) {
	var el_popup_container = $('#popup_container');

	if (!el_popup_container.hasClass('show')) {
		el_popup_container.addClass('show');
	}
	
	var el_popup_content = $('#popup_container .popup-frame .popup-content');

	if (typeof options !== undefined && typeof options.status !== undefined) {
		if (!el_popup_content.hasClass(options.status)) {
			el_popup_content.addClass(options.status);
		}
	}

	ReactDOM.render(content, el_popup_content[0]);

	if (typeof options !== undefined && options.auto_close === true) {
		setTimeout(function () {
			close_popup();
		}, 2000);
	}
}

export function close_popup() {
	var el_popup_container = $('#popup_container');
	var el_popup_content = $('#popup_container .popup-frame .popup-content');

	ReactDOM.render('', el_popup_content[0]);

	if (el_popup_content.hasClass('error')) {
		el_popup_content.removeClass('error');
	}

	if (el_popup_content.hasClass('success')) {
		el_popup_content.removeClass('success');
	}
	
	if (el_popup_container.hasClass('show')) {
		el_popup_container.removeClass('show');
	}
}

/**
 * @param errors
 * @param field_list
 * @param inputs_parent
 */
export function cross_form_errors(errors, field_list, inputs_parent) {
	let error_keys = Object.keys(errors);
	for (let item in field_list) {
		let input_el = inputs_parent.find('[name='+field_list[item]+']');
		let errors_el = inputs_parent.find('#'+field_list[item]+'_errors');
		if ($.inArray(field_list[item], error_keys) !== -1) {
			if (!input_el.hasClass('is-invalid')) {
				input_el.addClass('is-invalid');
			}
			errors_el.html(errors[field_list[item]]);
			if (!errors_el.hasClass('invalid-feedback')) {
				errors_el.addClass('invalid-feedback');
			}
		} else {
			if (input_el.hasClass('is-invalid')) {
				input_el.removeClass('is-invalid');
			}
			errors_el.html('');
			if (errors_el.hasClass('invalid-feedback')) {
				errors_el.removeClass('invalid-feedback');
			}
		}
	}
}

export function show_error_booking_popup(type = 'booking') {
    // redirectOnlyHome = true;
    let text_by_type = '';
    switch (type) {
        case "unlock_fail":
            text_by_type = 'unlocking';
            break;
        case "lock_fail":
            text_by_type = 'locking';
            break;
    }
    let content =
        <div className="row error-booking-popup">
            <div className="col-12 text-center">
                <div className="row m-3">
                    <div className="col-12 text-center gray">
                        {
                            type === 'booking' ? (
                                <>
                                    An error has occurred with this booking.
                                    <br/>
                                    Click ‘Go Back’ and try again.
                                    <br/>
                                    If the error persists, contact us.
                                </>
                            ) : (
                                <>
                                    Sorry, there is a problem {text_by_type} your vehicle.
                                    <br/>
                                    Please press the <b>Need Help?</b> icon to speak to a member of our staff who will be able to help you.
                                </>
                            )
                        }
                    </div>
                </div>
                <div className="row mb-4 text-center">
                    <div className="col-12">
                        <a href="tel:1300826883" className="btn-call-to-gecko green mx-auto" />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <div className="go-btn go-back mx-auto" onClick={close_popup} />
                    </div>
                </div>

            </div>
        </div>;
    show_popup(content, {auto_close: false});
}

export function show_not_found_booking_popup() {
    let content =
        <div className="row error-booking-popup">
            <div className="col-12 text-center">
                <div className="row m-3">
                    <div className="col-12 text-center gray">
                        Sorry, we don’t appear to be able to find your booking for entered information.
                        <br/>
                        <br/>
                        Please check that the <strong>BOOKING REFERENCE & EMAIL ADDRESS</strong> entered matches your booking or contact us for further assistance.
                    </div>
                </div>
                <div className="row mb-3">
                    <button type="button"
                            className="go-btn go-back mx-auto"
                            onClick={close_popup}/>
                </div>
            </div>
        </div>;
    show_popup(content, {auto_close: false});
}


export function getProfile() {
    let params = {
        action: 'api/booking/get_profile'
    };
    AJAX(bf_ajax_url, 'POST', params, {
        response_json: true,
        func_callback: function (resp) {
            if (resp.success === 1 && Object.keys(resp.data).length && resp.data.client_data) {
                window.gClientData = resp.data.client_data;
            }
        },
    });
}

window.getProfile = getProfile;

export function compressImage(file, callback) {

    /*function loadImage(image, file) {
        const reader = new FileReader();
        reader.onload = (event) => {
            image.src = event.target.result;
        };
        reader.readAsDataURL(file);

    };*/

//alert(navigator.userAgent);
    let b_version = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    let version_result = b_version ? parseInt(b_version[2], 10) : false;

    let safari_version = navigator.userAgent.match(/AppleWebKit\/([0-9]+)\./);
    let safari_version_result = safari_version ? parseInt(safari_version[1]) : false;

    let need_rotate =  (version_result === false || version_result < 85) && (safari_version_result === false || safari_version_result < 605);
//need_rotate = true;
    const oldFile = file;
    const reader = new FileReader();

    reader.readAsDataURL(oldFile);
    reader.onload = event => {
        const img = new Image();
        img.style.imageOrientation = 'none';
        img.src = event.target.result;
        img.onload = () => {
            let get_orientation = new Promise((resolve, fail) => {
                EXIF.getData(img, () => {
                    const orientation = EXIF.getTag(img, 'Orientation');
                    resolve(orientation);
                });
            });
            get_orientation.then((orientation) => {
                console.log('image orientation: ' + orientation);
                const canvas = document.createElement('canvas');
                let MAX_WIDTH = 1024;
                let MAX_HEIGHT = MAX_WIDTH;
                let width = img.width;
                let height = img.height;

                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                //ctx.save();
                //rotate
               // alert(need_rotate);
                if(need_rotate) {
                    //alert(orientation);
                    switch (Number(orientation)) {
                        // explained here: https://i.stack.imgur.com/6cJTP.gif
                        case 1:
                            break;

                        case 2:
                            ctx.translate(width, 0);
                            ctx.scale(-1, 1);
                            break;

                        case 3:
                            ctx.translate(width, height);
                            ctx.rotate((180 / 180) * Math.PI); // 180/180 is 1? No shit, but how else will you know its need 180 rotation?
                            break;

                        case 4:
                            ctx.translate(0, height);
                            ctx.scale(1, -1);
                            break;

                        case 5:
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 / 180) * Math.PI);
                            ctx.scale(1, -1);
                            break;

                        case 6:
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 / 180) * Math.PI);
                            ctx.translate(0, -height);
                            break;

                        case 7:
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((270 / 180) * Math.PI);
                            ctx.translate(-width, height);
                            ctx.scale(1, -1);
                            break;

                        case 8:
                            canvas.width = height;
                            canvas.height = width;
                            ctx.translate(0, width);
                            ctx.rotate((270 / 180) * Math.PI);
                            break;

                        default:
                            break;
                    }
                }
                //end rotate
                ctx.drawImage(img, 0, 0, width, height);
                //ctx.restore();

                ctx.canvas.toBlob((blob) => {
                    const nFile = new File([blob], oldFile.name, {
                        type: oldFile.type,
                        lastModified: Date.now()
                    });
                    if (typeof callback === 'function')
                        callback(nFile)
                }, oldFile.type, 1);
            });
        };
        reader.onerror = error => console.log(error);
    };
}
/*let temp_v = 1;
window['webkit'] = {} ;
window['webkit']['messageHandlers'] = {};
window['webkit']['messageHandlers']['iosGetToken'] = {
    postMessage : function (a) {
        iosCallback('test' + temp_v);
        temp_v++;
    }
}*/

export function getEmailForMessages() {
    let email = localStorage.getItem('bm_email_messages');
    return email !== null ? email : '';
}

export function setEmailForMessages(email, updateCount = true) {
    window.localStorage.setItem('bm_email_messages', email);
    setCookie('bm_email_messages', email, 3*365);
    get_phone_id();
    if (updateCount && typeof window.getCountMessages ===  'function') {
        window.getCountMessages();
    }
}

export function get_phone_id() {
    if(window.webkit) {
        if(window.webkit.messageHandlers) {
            if(window.webkit.messageHandlers.iosGetToken) {
                window.webkit.messageHandlers.iosGetToken.postMessage('');
            }
        }
    }
    if(window.android) {
        window.android.androidGetToken();
    }
}

export function setCookie(name,value,days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
export function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

window.iosCallback = (token) => {
    let email = window.localStorage.getItem('bm_email_messages');
    window.addPhoneId(token, null, email);
};

window.addPhoneId = (phone_id, callback, email = null) => {
    let bulk_notify = getCookie('bm_bulk_notify');
    bulk_notify = (bulk_notify == 1) ? 1 : 0;

    let params = {
        action: 'api/booking/add_phone_id',
        phone_id,
        bulk_notify: bulk_notify
    };
    if (!!email) {
        params.email = email;
    }
    AJAX(bf_ajax_url, 'POST', params, {
        response_json: true,
        func_callback: function (resp) {
            let res = resp.success === 1;
            if (typeof callback === 'function') {
                callback(res);
            }
            return res;
        },
    });
};

export function device_inform(b) {
    console.log('device_inform: ' + b);
    b = false;//temporary disable
    if (typeof window.android !== "undefined" && typeof window.android.androidSetAi === 'function') {
        window.android.androidSetAi(b);
    }
    return true;
}

export function gTagClickEvent(event_category, event_label) {
    if (typeof gtag === 'function') {
        gtag('event', 'click', {
            'event_category': event_category,
            'event_label': event_label
        });
    }
}
window.gTagClickEvent = gTagClickEvent;

export const safeStringify = (obj, indent = 2) => {
    let cache = [];
    const retVal = JSON.stringify(
        obj,
        (key, value) =>
            typeof value === "object" && value !== null
                ? cache.includes(value)
                    ? undefined // Duplicate reference found, discard key
                    : cache.push(value) && value // Store value in our collection
                : value,
        indent
    );
    cache = null;
    return retVal;
};

export function on_interstate_exit(e) {
    if (e.clientY < 0) {
        if($('#interstate-exit').length && $(".modal.in").length == 0) {
            $('input[name="booking-data"]',$('#interstate-exit')).val(window.booking_form_data_interstate_exit);
            jQuery('#interstate-exit').modal('show');
        }
    }
}

export function getLocationDetailsById(id) {
    const locs = window.bf_detailed_locations.locations ? window.bf_detailed_locations.locations : window.bf_detailed_locations;
    const locations = Array.isArray(locs) ? locs : Object.values(locs);

    if (locations) {
        const location = locations.find(loc => (loc.rcm_id === id) || (loc.rcm === id) || (loc.id === id));
        if (location) {
            return location;
        }
        else {
            return null;
        }
    }
    else {
        return null;
    }
}